import React from 'react';
import { BsStopwatch } from '@react-icons/all-files/bs/BsStopwatch';
import { LIGHT_THEME } from '@bucketplace/design-system';

import { decorateComponent } from '../../documentComponents';
import { Countdown } from './Countdown';
import { CountdownInspector } from './Countdown.Inspector';

export default decorateComponent(Countdown, 'block', {
  id: 'countdown',
  label: '카운트다운',
  allowedChildren: [],
  allowedParent: ['page', 'block'],
  defaultProps: {
    duration: {},
    timerPrefix: 'start',
    align: 'left',
    color: LIGHT_THEME.base.neutral600,
  },
  renderIcon: () => <BsStopwatch />,
  renderInspector: CountdownInspector,
});
